import { render, staticRenderFns } from "./ModelDiseases.vue?vue&type=template&id=6f21671e&scoped=true"
import script from "./ModelDiseases.vue?vue&type=script&lang=js"
export * from "./ModelDiseases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21671e",
  null
  
)

export default component.exports